import {IHttpPromise, IHttpService} from 'angular';
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';

export class TestFaelleRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string) {
        this.serviceURL = REST_API + 'testfaelle';
        this.http = $http;
    }

    public getServiceName(): string {
        return 'TestFaelleRS';
    }

    public createTestFall(testFall: string, tsSchadenfallStatus: TSSchadenfallStatus, anlaufstelleId: string,
                          anzahl: number, besitzerId: string): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/testfall/' + encodeURIComponent(testFall) + '/'
            + tsSchadenfallStatus + '/' + anzahl + '/' + encodeURIComponent(anlaufstelleId) + '/' + encodeURIComponent(besitzerId));
    }

    public createTestFallVersicherungsbeitrag(testVersBeitragStatus: TSSchadenfallStatus,
                                              anzahl: number): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/testfall/versicherungsbeitrag/'
            + testVersBeitragStatus + '/' + anzahl);
    }

    public sendTestMail(schadenfallNummer: string, mail: string): IHttpPromise<String> {
        return this.http.get(this.serviceURL + '/testmail/' + encodeURIComponent(mail) + '/' + schadenfallNummer);
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/service/testFaelleRS.rest.ts